// Shared Google Maps loader configuration
// This ensures Google Maps is loaded only once with consistent options

import { useJsApiLoader } from '@react-google-maps/api';

// Libraries needed by all components
const GOOGLE_MAPS_LIBRARIES = ['places'];

// Single Google Maps API Key source
const getApiKey = () => {
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDA2ypkcp51xJQA2N5i2xE2riayh9l-NHo';
};

// Shared hook for Google Maps
export const useGoogleMaps = () => {
  return useJsApiLoader({
    id: 'albmove-google-maps',
    googleMapsApiKey: getApiKey(),
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
};

export const GOOGLE_MAPS_API_KEY = getApiKey();
